var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.587,0 C6.628,0 7.517,0.639 7.89,1.544 L18.931,1.544 C19.483,1.544 19.931,1.992 19.931,2.544 C19.931,3.096 19.483,3.544 18.931,3.544 L7.838,3.544 C7.44,4.392 6.586,4.983 5.587,4.983 C4.589,4.983 3.735,4.392 3.337,3.544 L1,3.544 C0.447,3.544 0,3.096 0,2.544 C0,1.992 0.447,1.544 1,1.544 L3.285,1.544 C3.658,0.639 4.547,0 5.587,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9307,0 L19.9307,4.982 L0,4.982 L0,0 L19.9307,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.923,0 C16.002,0 16.912,0.689 17.258,1.648 L18.931,1.648 C19.484,1.648 19.931,2.096 19.931,2.648 C19.931,3.2 19.484,3.648 18.931,3.648 L17.117,3.648 C16.699,4.438 15.879,4.982 14.923,4.982 C13.968,4.982 13.148,4.438 12.73,3.648 L1,3.648 C0.448,3.648 0,3.2 0,2.648 C0,2.096 0.448,1.648 1,1.648 L12.588,1.648 C12.935,0.689 13.845,0 14.923,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9307,0 L19.9307,4.9829 L0,4.9829 L0,0 L19.9307,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.688,0 C6.746,0 7.644,0.663 8.005,1.593 L18.931,1.593 C19.484,1.593 19.931,2.041 19.931,2.593 C19.931,3.145 19.484,3.593 18.931,3.593 L7.912,3.593 C7.504,4.414 6.666,4.983 5.688,4.983 C4.71,4.983 3.872,4.414 3.464,3.593 L1,3.593 C0.448,3.593 0,3.145 0,2.593 C0,2.041 0.448,1.593 1,1.593 L3.371,1.593 C3.732,0.663 4.63,0 5.688,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.469136006766348e-13 0.9999999999999822)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.931,0 19.931,4.983 0,4.983 0,0",
    stroke: "none",
    fill: "#FF7700"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 6.4375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0002999999999993008 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0003,0 19.931,0 19.931,4.982 0.0003,4.982 0.0003,0",
    stroke: "none",
    fill: "#FF7700"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 13.034)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0002999999999993008 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0003,0 19.931,0 19.931,4.9829 0.0003,4.9829 0.0003,0",
    stroke: "none",
    fill: "#FF7700"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.38816b70c31dc4a5ad5827cce1989386.svg";
export { ForwardRef as ReactComponent };